module.exports = __webpack_public_path__ + "assets/img/12b.619aa1f5.jpg";